import styles from "./Skeleton.module.scss";
import { classNames } from "../../../../lib/classNames";

interface SkeletonProps {
    className?: string;
}
export const Skeleton = ({ className }: SkeletonProps) => {
    return <div className={classNames({ cls: styles.skeleton, additional: [className] })}></div>;
};
